import { Route } from 'vue-router';
import SurveyMode from './SurveyMode';
import UrlParsedInfo from './UrlParsedInfo';
import Source from './Source';

export default class URLParser {
  public static parseNewTransactionFromParams(route: Route): UrlParsedInfo {
    return {
      // hash: route.params
      apitoken: route.params.apitoken,
      transactionId: route.params.transactionId,
      attemptId: route.params.attemptId,
      store_id: route.params.storeId,
      employee_id: route.params.employeeId,
      template: route.params.template,
      mode: route.name as SurveyMode,
      ...route.query,
    };
  }

  public static parseNewTransactionTotemFromParams(route: Route): UrlParsedInfo {
    return {
      // hash: route.params
      apitoken: route.params.apitoken,
      store_id: route.params.storeId,
      employee_id: route.params.employeeId,
      name: 'cliente',
      cpf: '0',
      source: Source.tablet,
      template: route.params.template,
      mode: route.name as SurveyMode,
      ...route.query,
    };
  }
}
